export default [
  {
    path: "/feeConfigurations",
    component: () => import(/* webpackChunkName: "deposits" */ "./layout"),

    children: [
      {
        path: "/feeConfigurations/deposits",
        name: "deposits.index",
        component: () => import(/* webpackChunkName: "deposits" */ "./index"),
      },
      {
        path: "/feeConfigurations/:id/deposits/offers",
        name: "deposits.offers.index",
        component: () => import(/* webpackChunkName: "cashouts" */ "./offers/index"),
      },
      {
        path: "/feeConfigurations/:feeConfigurationId/depositOffers/:id",
        props: true,
        name: "deposits.offers.show",
        component: () => import(/* webpackChunkName: "deposits.payinmethods" */ "./offers/show"),
      },
      {
        path: "/feeConfigurations/:id/deposits/payinmethods",
        name: "deposits.payinmethods.index",
        props: true,
        component: () =>
          import(/* webpackChunkName: "deposits.payinmethods" */ "./payinMethods/index"),
      },
      {
        path: "/feeConfigurations/:feeConfigurationId/payInMethods/:id",
        props: true,
        name: "deposits.payinmethods.show",
        component: () =>
          import(/* webpackChunkName: "deposits.payinmethods" */ "./payinMethods/show"),
      },
      {
        path: "/feeConfigurations/:id/deposits/countries",
        name: "deposits.countries.index",
        props: true,
        component: () => import(/* webpackChunkName: "deposits.countries" */ "./countries/index"),
      },
      {
        path: "/feeConfigurations/:feeConfigurationId/countries/:id",
        props: true,
        name: "deposits.countries.show",
        component: () => import(/* webpackChunkName: "deposits.countries" */ "./countries/show"),
      },
    ],
  },
];
